import React, { Fragment, useEffect, useState } from 'react';
import { Row, NavItem, Nav } from 'reactstrap';
import classnames from "classnames";
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { gAPI_Internal_Property_By_Id } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Languages from '../../../../../../data/languages';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
function LanguageTabs({ propertyId, setLanguage, selectedTab, locale, integrationLanguages }) {
    const [propertyLanguage, setPropertyLanguage] = useState([]);
    const [isTabVisible, setIsTabVisible] = useState(true);

    useEffect(() => {
        setLanguage(locale === "hk" ? "zh-TW" : locale);
    }, [locale]);

    useEffect(() => {
        if (integrationLanguages === undefined && propertyId !== "-1") {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
            }).then((res) => {
                if (res.data) {
                    if (res.data.languages.length === 1 && res.data.languages.includes("en")) {
                        setIsTabVisible(false);
                    }
                    else {
                        var lang = Languages.filter(k => res.data.languages.includes(k.code));
                        setPropertyLanguage(lang);
                        setIsTabVisible(true);
                    }
                }
            });
        }
        else {
            if (integrationLanguages !== undefined) {
                var lang = Languages.filter(k => integrationLanguages.includes(k.code));
                setPropertyLanguage(lang);
                setIsTabVisible(true);
            }
        }
    }, [propertyId, integrationLanguages]);
    const handleClickLang = (lang) => {
        setLanguage(lang);
    }
    return isTabVisible && (<Fragment>
        <Row>
            <Colxx xxs="12" lg="12">
                <Nav tabs className="card-header-tabs separator-tabs mb-4 ml-2  mr-0">
                    <style>{style_css}</style>
                    {propertyLanguage.map((k, i) => (
                        <NavItem key={i} className="text-center ml-2" style={{ width: 'auto', background: '' }}>
                            <NavLink
                                style={{ background: 'none', cursor: 'pointer' }}
                                className={classnames({
                                    active: selectedTab === k.code,
                                    "nav-link": true
                                })}
                                onClick={() => handleClickLang(k.code)}
                                to="#"
                            >
                                <span
                                    style={{ color: `${selectedTab === k.code ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
                                >
                                    {k.code}
                                </span>
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </Colxx>
        </Row >
    </Fragment>)
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, email } = settings;
    return {
        propertyId,
        locale,
        email
    };
};

export default injectIntl(connect(mapStateToProps)(LanguageTabs));